import { useParams } from "react-router-dom";
import { ResourceHunterTabs } from "../components/resourceHunter/ResourceHunterTabs";
import { getActiveServerSlug } from "../utils/siteContext";
import { useQuery } from "@tanstack/react-query";
import { displayBonusLabel, getZoneBonusHistory } from "../api/bonuses";

export function BonusZonePage() {
  const { zoneSlug = "" } = useParams();
  const serverSlug = getActiveServerSlug();

  const query = useQuery({
    queryKey: ["bonus-zone-history", serverSlug, zoneSlug],
    queryFn: () => getZoneBonusHistory(serverSlug, zoneSlug),
    enabled: zoneSlug.length > 0,
  });

  const data = query.data;

  return (
    <main className="main-content">
      <section className="page-hero">
        <div className="content-wrapper py-4">
          <h1 className="display-6 fw-semibold mb-3">
            Resource Hunter Bonuses
            <span className="page-hero__server d-block">{serverSlug}</span>
          </h1>
          <p className="fs-3 mb-0">{data?.zone.name ?? "Zone Bonus History"}</p>
        </div>
      </section>

      <ResourceHunterTabs activeTab="trends" />

      <div className="content-wrapper py-4">
        {query.isLoading ? <p>Loading...</p> : null}

        {data ? (
          <div className="row g-4">
            <div className="col-lg-4">
              <section className="report-panel p-3 p-md-4">
                <h2 className="h4 mb-3">Frequency</h2>
                <div className="d-grid gap-2">
                  {data.stats.map((stat) => (
                    <div className="bonus-zone-card" key={stat.bonusTypeId}>
                      <div className="fw-semibold">{displayBonusLabel({ key: stat.bonus, label: stat.bonusLabel })}</div>
                      <div className="small text-body-secondary">
                        {stat.count} recorded days
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>

            <div className="col-lg-8">
              <section className="report-panel p-3 p-md-4">
                <h2 className="h4 mb-3">History</h2>
                <div className="table-responsive">
                  <table className="table table-dark table-striped align-middle">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Bonus</th>
                        <th>State</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.history.map((row) => (
                        <tr key={row.id}>
                          <td>{row.bonusDate}</td>
                          <td>{displayBonusLabel({ key: row.bonus, label: row.bonusLabel })}</td>
                          <td>{row.state}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </section>
            </div>
          </div>
        ) : null}
      </div>
    </main>
  );
}
